import * as React from "react";
import {
    Popover,
    Box,
    Button,
} from "@mui/material";
import {ReassignCases} from "../ReassignCases/index";
import {Assignment, ChangeCircle, ChangeCircleOutlined, Undo} from "@mui/icons-material";
import { ExcludeCases } from "../ExcludeCases/index";
import { RevertApproval } from "../RevertApproval/index";
import { managerViews } from "../../organisms/workItemsTable";
import { WorkitemStatus } from "../ProjectSelectColumn/types";
import { useCaseTransferPermissionsConfig } from "../../../hooks/useCaseTransferPermissionsConfig";

type Props = {
    client: any;
    anchorEl: any;
    handleClose: any;
    handleMove: any;
    coders: any;
    selected: any;
    allSelected?: boolean;
    isChangeOwner?: boolean;
    activeView:string,
    handleAfterExclusion: () => void,
    serviceLine:string,
    isQualityAssessment?: boolean;
    isCQAManager?: boolean;
    handleAfterRevert?: () => void;
    cqaWorkitemStatus?: string;
};

export const ActionMenu = ({
    anchorEl,
    selected,
    handleClose,
    handleMove,
    coders,
    client,
    allSelected,
    activeView,
    handleAfterExclusion,
    serviceLine,
    isQualityAssessment,
    isCQAManager,
    handleAfterRevert,
    cqaWorkitemStatus,
    ...props
}: Props) => {

    const [openReassign, setOpenReassign] = React.useState(false);
    const [openExcludeCases, setOpenExcludeCases] = React.useState(false);
    const [openRevertApproval, setOpenRevertApproval] = React.useState(false);
    const handleOpenReassign = () => setOpenReassign(true);
    const handleCloseReassign = () => setOpenReassign(false);
    const handleOpenExcludeCases = () => setOpenExcludeCases(true);
    const handleCloseExcludeCases = () => setOpenExcludeCases(false);
    const handleOpenRevertApproval = () => setOpenRevertApproval(true);
    const handleCloseRevertApproval = () => setOpenRevertApproval(false);

    const { canShowCaseTransferOption } = useCaseTransferPermissionsConfig();

    const handleReassign = (selected, assignee,is_manual_assignment) => {
        handleMove(selected, assignee,is_manual_assignment);
        handleCloseReassign();
    }
    return (
        <Popover
            open={Boolean(anchorEl)}
            onClose={handleClose}
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
            }}
        >
            <Box
                sx={{
                    maxHeight: "80vh",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "left",
                    alignItems:"flex-start"
            }}
            >
                {/* CQA-only bulk actions when in Quality Assessment mode */}
                {isQualityAssessment ? (
                    <>
                        {isCQAManager && (
                            <>
                                <Button
                                    onClick={handleOpenReassign}
                                    disableRipple={true}
                                    sx={{ color: "black", padding: "10px"}}
                                >
                                    <Assignment style={{marginRight: "0.5em"}}/>
                                    {"Reassign"}
                                </Button>
                                
                                {(cqaWorkitemStatus === WorkitemStatus.CQA_APPROVED || cqaWorkitemStatus === WorkitemStatus.CQA_COMPLETE) && (
                                    <Button
                                        onClick={handleOpenRevertApproval}
                                        disableRipple={true}
                                        sx={{ color: "black", padding: "10px"}}
                                    >
                                        <Undo style={{marginRight: "0.5em"}}/>
                                        {cqaWorkitemStatus === WorkitemStatus.CQA_COMPLETE ? "Revert Submission" : "Revert Approval"}
                                    </Button>
                                )}
                            </>
                        )}
                    </>
                ) : (
                    /* Regular worklist bulk actions */
                    <>
                       {canShowCaseTransferOption(activeView) && (
                            <Button
                                onClick={handleOpenReassign}
                                disableRipple={true}
                                sx={{ color: "black", padding: "10px"}}
                            >
                                <Assignment style={{marginRight: "0.5em"}}/>
                                {props?.isChangeOwner ? "Move to a different coder" : "Reassign"}
                            </Button>
                        )}
                        <Button
                            onClick={handleOpenExcludeCases}
                            disableRipple={true}
                            sx={{ color: "black", padding: "10px"}}
                        >
                            <Assignment style={{marginRight: "0.5em"}}/>
                            {"Exclude"}
                        </Button>
                    </>
                )}
                <ReassignCases
                    selected={selected}
                    open={openReassign}
                    handleClose={handleCloseReassign}
                    handleMove={handleReassign}
                    coders={coders}
                    allSelected={allSelected}
                />
                <ExcludeCases
                    selected={selected}
                    open={openExcludeCases}
                    handleClose={handleCloseExcludeCases}
                    handleAfterExclusion={handleAfterExclusion}
                    serviceLine={serviceLine}
                />
                <RevertApproval
                    selected={selected}
                    open={openRevertApproval}
                    handleClose={handleCloseRevertApproval}
                    handleAfterRevert={handleAfterRevert || (() => {})}
                    isQualityAssessment={isQualityAssessment}
                    cqaWorkitemStatus={cqaWorkitemStatus}
                />
            </Box>
        </Popover>
    )
}
